import { useMemo } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import ListSelect from "src/components/ListSelect";

import {
  getDefaultAvatarId,
  getAvatars,
  getDefaultAvatar
} from "src/modules/avatar/duck/selectors";
import { withParentStation } from "src/modules/parent-station/ParentStation/Context";
import CorrespondingAvatar from "src/modules/avatar/components/CorrespondingAvatar";
import { useTranslation } from "react-i18next";

function AvatarSelector({
  onClose,
  openFlow,
  avatars,
  selectedAvatarId,
  defaultAvatar,
  parentStation,
  selectedAvatar
}) {
  const { t } = useTranslation();
  const filterSelectedAvatar = useMemo(
    () =>
      avatars.filter(
        (avatar) =>
          avatar.objectId !== (selectedAvatar?.objectId || selectedAvatarId)
      ),
    [avatars, selectedAvatarId, selectedAvatar]
  );

  const items = useMemo(
    () =>
      filterSelectedAvatar.map((avatar) => ({
        id: avatar.objectId,
        name: avatar.name,
        contentBeforeName: (
          <CorrespondingAvatar avatar={avatar} width="32px" height="32px" />
        )
      })),
    [filterSelectedAvatar]
  );
  return (
    <ListSelect
      isOpen={true}
      onClose={onClose}
      heading={t("avatar.avatarSelector.heading")}
      items={items}
      selectedItem={{
        id: (selectedAvatar || defaultAvatar).objectId,
        name: (selectedAvatar || defaultAvatar).name,
        contentBeforeName: (
          <CorrespondingAvatar
            avatar={selectedAvatar || defaultAvatar}
            width="32px"
            height="32px"
          />
        )
      }}
      onSelect={(id) => {
        parentStation.switchAvatar(id);
        onClose();
      }}
      onManage={openFlow}
      manageButtonText={t("avatar.avatarSelector.openFlow")}
    />
  );
}

function mapStateToProps(state) {
  return {
    defaultAvatar: getDefaultAvatar(state),
    selectedAvatarId: getDefaultAvatarId(state),
    avatars: Object.values(getAvatars(state)).filter(
      (avatar) => avatar.deleted === false
    )
  };
}

const enhance = compose(withParentStation, connect(mapStateToProps));

export default enhance(AvatarSelector);
